import { useTranslation } from 'react-i18next';
export const useTypedTranslation = () => {
    const { t: rawT, i18n } = useTranslation();
    const t = (key, options) => {
        return rawT(key, options);
    };
    return { t, i18n };
};
